import { ReactNode, useCallback } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { CrossIcon } from "@/shared/icons";
import { Button } from "@/shared/ui";
import closeTablet from "@/domains/tablet/helpers/closeTablet";

type Props = {
  children: ReactNode;
  isTablet?: boolean;
  onClose?: () => void;
};

export default function EstateSlotsWrapper({ isTablet = true, onClose, children }: Props) {
  const { t } = useTranslation("estate");

  const handleClose = useCallback(() => {
    if (isTablet) closeTablet();
    if (onClose) onClose();
  }, [isTablet, onClose]);

  return (
    <div
      className={clsx(
        "absolute z-10 top-2.5 left-3.5 flex flex-col w-[calc(100%-1.625rem)] h-[calc(100%-1.25rem)] px-4 pt-5 bg-dark-900 rounded-4",
      )}
    >
      <div className="flex justify-between w-full mb-4">
        <div className="flex items-center gap-2.5">
          <img src="/svg/home-menu/my-estate.svg" className="w-10.5 h-10.5" alt="estate" />
          <div>
            <div className="text-15 font-bold text-inverted uppercase">
              {t("estate.header.title")}
            </div>
            <div className="text-14 font-medium text-gray/50">{t("estate.header.description")}</div>
          </div>
        </div>
        <Button className="shrink-0 size-8 p-0" color="gray" variant="soft" onClick={handleClose}>
          <CrossIcon className="size-3" />
        </Button>
      </div>
      {children}
    </div>
  );
}
